import React from 'react';
import { useSelector } from 'react-redux';
import '../../TNStore/TNStoreDetails/tnStoreDetails.scss'
import _isEqual from 'lodash/isEqual';
import {Link} from 'react-router-dom';

const GarageArchiveDetails = ({ car }) => {
  const {accessFeatures} = useSelector(({user}) => user);
  const check = car && !_isEqual(car, {});
  const isExtensionThreeImplementaition = accessFeatures["extension.implementation.type.three"]

  return (
    <div className="overdue-content-section">
      <table className="table hover">
        <thead>
        <tr className="tnStoreDetails-table-header">
          <th scope="col">
            <p>Номер</p>
          </th>
          <th scope="col">
            <p>Клиент</p>
          </th>
          <th scope="col">
            <p>Наименование</p>
          </th>
          <th scope="col">
            <p>
              Дней <br />
              просрочки
            </p>
          </th>
          {!isExtensionThreeImplementaition && <th scope="col">
            <p>
              Дней льготного<br />
              срока
            </p>
          </th>}
          <th scope="col">
            <p>Количество</p>
          </th>
          <th scope="col">
            <p>
              Сумма на выкуп <br /> до перевода, руб.
            </p>
          </th>
          <th scope="col">
            <p>
              Размер <br />
              микрозайма, руб.
            </p>
          </th>
          <th scope="col">
            <p>
              Цена <br />
              реализации, руб.
            </p>
          </th>
        </tr>
        </thead>
        <tbody>
        {check &&
          <tr>
            <td>
              <p>
                <Link className="table-link" to={`client/${car.clientId}/contracts/${car.id}`}>
                  <span>{car.dealNumber || car.id}</span>
                </Link>
              </p>
            </td>
            <td>
              <p>{car.clientFullName}</p>
            </td>
            <td>
              <p>{car.positions[0].names?.join(', ')}</p>
            </td>
            <td>
              <p>{car.delayDays}</p>
            </td>
            {!isExtensionThreeImplementaition && <td>
              <p>{car.graceDays}</p>
            </td>}
            <td>
              <p>{car.positions[0].quantity}</p>
            </td>
            <td>
              <p>{car.totalToPay.toFixed(2)}</p>
            </td>
            <td>
              <p>{car.amount.toFixed(2)}</p>
            </td>
            <td>
              <p>{car.totalEstimatedValue.toFixed(2)}</p>
            </td>
          </tr>
        }
        </tbody>
        <tfoot>
        { check && (
          <tr className="tnStoreDetails-table-footer">
            <td colSpan="5">
              <p>Итого</p>
            </td>
            <td colSpan="2">
              <p>Размер микрозайма:</p>
              <p>Оценочная стоимость:</p>
            </td>
            <td>
              <p>
                {car.amount.toFixed(2)}{' '} руб.
              </p>
              <p>
                {car.totalEstimatedValue.toFixed(2)}{' '} руб.
              </p>
            </td>
          </tr>
          )
        }
        </tfoot>
      </table>
    </div>
  );
}

export default GarageArchiveDetails